(function ($) {
	$(document).on('click', '.accordion-item-title', function (e) {
		e.preventDefault();
		$(this).parent().toggleClass('open');
		$(this).siblings('.accordion-item-content').slideToggle();
	});
})(jQuery);
